import { render, staticRenderFns } from "./AddPaymentMethod.vue?vue&type=template&id=3442823a&scoped=true&"
import script from "./AddPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./AddPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./AddPaymentMethod.vue?vue&type=style&index=0&id=3442823a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3442823a",
  null
  
)

export default component.exports